export default __webpack_public_path__ + "static/media/purple-squares.f7b2e235.svg";